import { Dialog, IconButton, Typography } from '@mui/material'
import { Dismiss24Regular } from '@/components/Icon'
import IntegrationsGrid from './IntegrationsGrid'
import IntegrationsModalSidebar from './IntegrationsModalSidebar'
import IntegrationsModalToolbar from './IntegrationsModalToolbar'
import { useIntegrationsModal } from './IntegrationsModalContext'
import { useIntegrationsMarketplaceModel } from './useIntegrationsMarketplaceModel'
import styles from './integrationsModal.module.scss'

export default function IntegrationsModal() {
  const { open, closeIntegrations } = useIntegrationsModal()
  const model = useIntegrationsMarketplaceModel()

  const emptyMessage = 'No integrations match your filters.'

  return (
    <Dialog
      open={open}
      onClose={closeIntegrations}
      maxWidth={false}
      scroll="paper"
      aria-labelledby="integrations-modal-title"
      slotProps={{
        paper: { className: styles.dialogPaper, elevation: 0 },
      }}
    >
      <header className={styles.header}>
        <Typography id="integrations-modal-title" component="h2" className={styles.title}>
          Integrations
        </Typography>
        <IconButton
          type="button"
          aria-label="Close integrations"
          onClick={closeIntegrations}
          size="small"
          className={styles.closeButton}
        >
          <Dismiss24Regular className={styles.closeIcon} aria-hidden />
        </IconButton>
      </header>
      <div className={styles.body}>
        <IntegrationsModalSidebar categoryId={model.categoryId} onCategoryChange={model.setCategoryId} />
        <div className={styles.main}>
          <IntegrationsModalToolbar
            query={model.query}
            onQueryChange={model.setQuery}
            visibleCount={model.visibleCount}
            totalCount={model.totalCount}
          />
          <div className={styles.mainScroll}>
            <IntegrationsGrid
              apps={model.gridApps}
              showPopularHeading={model.showPopularSection}
              emptyMessage={emptyMessage}
            />
          </div>
        </div>
      </div>
    </Dialog>
  )
}
